module.exports = __webpack_public_path__ + "static/media/podshipnik.72e11d34.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/podshipnik.png
// module id = 167
// module chunks = 0